export const siteInfo = {
  name: '51黑料网',
  slogan: '今日黑料 · 每日更新',
  tagline: '明星网红爆料吃瓜，一网打尽',
};

export const navLinks = [
  { id: 'timeline', label: '今日黑料', href: '#timeline' },
  { id: 'featured', label: '明星黑料', href: '#featured' },
  { id: 'collections', label: '网红黑料', href: '#collections' },
  { id: 'rank', label: '吃瓜榜单', href: '#rank' },
  { id: 'comments', label: '吃瓜现场', href: '#comments' },
];

export const hero = {
  tag: '今日黑料 · 每日更新',
  description:
    '51黑料网聚合今日明星、网红圈最新黑料与爆料内容，覆盖吃瓜群众关心的热门事件。无论你想看明星黑料还是网红黑料，这里都能快速找到线索与讨论，每日更新，满足你的吃瓜需求。',
  keywords: ['今日黑料', '明星黑料', '网红黑料', '爆料', '吃瓜', '明星爆料', '网红爆料'],
  primaryCta: '查看今日黑料',
  secondaryCta: '进入爆料合集',
  coverImage:
    'https://readdy.ai/api/search-image?query=Dramatic%20warm%20crimson%20and%20amber%20toned%20abstract%20editorial%20scene%20of%20a%20single%20spotlight%20beam%20cutting%20through%20hazy%20backstage%20smoke%20with%20glowing%20dust%20particles%20and%20soft%20lens%20flares%2C%20cinematic%20bokeh%2C%20deep%20velvety%20shadows%2C%20stylized%20glossy%20magazine%20cover%20aesthetic%2C%20no%20people%2C%20no%20text%2C%20rich%20harmonious%20warm%20color%20palette%2C%20ultra%20high%20detail&width=900&height=1100&seq=hl-hero-main&orientation=portrait',
  subImage:
    'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20close%20up%20of%20a%20glossy%20microphone%20silhouette%20against%20blurred%20crimson%20stage%20bokeh%20with%20golden%20rim%20light%2C%20stylized%20entertainment%20news%20still%2C%20soft%20cinematic%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20consistent%20amber%20and%20crimson%20palette%2C%20high%20detail%20editorial%20texture&width=600&height=600&seq=hl-hero-sub&orientation=squarish',
  coverTag: '今日头条爆料',
  coverTitle: '顶流深夜密会画面流出，超话连夜清空',
  liveBadge: '+128',
};

export const heroMetrics = [
  { value: '12,486', label: '累计爆料' },
  { value: '326', label: '今日更新' },
  { value: '48.2万', label: '在吃瓜' },
];

export const indexEntries = [
  {
    id: 'star',
    icon: 'ri-star-line',
    title: '明星黑料',
    desc: '演艺圈一手爆料',
    count: '3,102 条',
  },
  {
    id: 'influencer',
    icon: 'ri-live-line',
    title: '网红黑料',
    desc: '直播带货翻车合集',
    count: '2,764 条',
  },
  {
    id: 'today',
    icon: 'ri-fire-line',
    title: '今日吃瓜',
    desc: '实时快讯滚动更新',
    count: '326 条',
  },
  {
    id: 'hot',
    icon: 'ri-hashtag',
    title: '热点追踪',
    desc: '热搜词条发酵中',
    count: '188 条',
  },
  {
    id: 'collection',
    icon: 'ri-folder-shield-2-line',
    title: '爆料合集',
    desc: '按事件成册整理',
    count: '96 册',
  },
  {
    id: 'rank',
    icon: 'ri-bar-chart-2-line',
    title: '吃瓜榜单',
    desc: '热度排行每日刷新',
    count: 'Top 50',
  },
];

export const featuredStories = {
  cover:
    'https://readdy.ai/api/search-image?query=Wide%20warm%20toned%20abstract%20cinematic%20scene%20of%20a%20red%20carpet%20stretch%20bathed%20in%20amber%20spotlights%20with%20dramatic%20smoke%20and%20floating%20golden%20sparkles%2C%20blurry%20crowd%20silhouettes%20far%20in%20background%2C%20stylized%20gossip%20magazine%20cover%20aesthetic%2C%20no%20readable%20text%2C%20consistent%20crimson%20amber%20palette%2C%20ultra%20high%20detail&width=1200&height=800&seq=hl-featured&orientation=landscape',
  badge: '置顶爆料',
  title: '红毯现场临时换人风波：某剧组男女主疑似全程零交流',
  excerpt:
    '昨晚某年度盛典红毯环节，原本同框的男女主被临时拆开走位，现场照片流出后迅速冲上热搜，剧组至今未作回应。',
  tags: ['明星爆料', '热搜'],
  stats: ['阅读 86.4万', '讨论 5,120', '更新于 21:40'],
  list: [
    {
      id: 'f1',
      title: '同一场活动全程避嫌，后台通行证记录被扒',
      meta: '明星黑料 · 2 小时前',
    },
    {
      id: 'f2',
      title: '工作室删除早前合体海报，评论区已关闭',
      meta: '今日黑料 · 3 小时前',
    },
    {
      id: 'f3',
      title: '双方粉丝后援会先后发布声明，措辞微妙',
      meta: '吃瓜现场 · 5 小时前',
    },
  ],
};

export const statItems = [
  { value: '12,486', label: '累计爆料条数', icon: 'ri-archive-2-line' },
  { value: '326', label: '今日更新爆料', icon: 'ri-refresh-line' },
  { value: '48.2万', label: '正在吃瓜的人', icon: 'ri-user-voice-line' },
  { value: '1,204', label: '明星网红词条', icon: 'ri-contacts-book-2-line' },
];

export const timelineItems = [
  {
    id: 't1',
    time: '14:32',
    date: '10月10日',
    tag: '明星黑料',
    title: '某顶流歌手被拍深夜密会，后援会疑似连夜清空超话',
    excerpt:
      '有网友称拍到该歌手深夜从某公寓离开，相关话题在三小时内阅读量破百万，经纪公司暂未回应。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20still%20of%20a%20city%20rooftop%20at%20dusk%20glowing%20with%20crimson%20and%20amber%20neon%20reflections%2C%20stylized%20sunset%20haze%20with%20subtle%20film%20grain%2C%20cinematic%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-01&orientation=landscape',
    comments: 1284,
    likes: 862,
    hot: true,
  },
  {
    id: 't2',
    time: '15:10',
    date: '10月10日',
    tag: '网红黑料',
    title: '带货主播直播间口误翻车，品牌方连夜下架联名款',
    excerpt:
      '该主播在介绍产品时说错品牌定位，弹幕瞬间炸锅，合作品牌当晚悄悄下架了联名商品链接。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20close%20up%20of%20luxury%20black%20car%20headlights%20glowing%20amber%20on%20a%20wet%20night%20street%20with%20crimson%20reflections%2C%20moody%20cinematic%20bokeh%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail%20editorial%20texture&width=480&height=360&seq=hl-tl-02&orientation=landscape',
    comments: 968,
    likes: 541,
    hot: false,
  },
  {
    id: 't3',
    time: '16:05',
    date: '10月10日',
    tag: '今日吃瓜',
    title: '影帝旧照突然曝光登上热搜，评论区吵成一片',
    excerpt:
      '一张十年前的片场旧照被翻出，网友对细节展开逐帧分析，相关话题半天内出现多个衍生词条。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20backstage%20dressing%20room%20vanity%20mirror%20framed%20by%20rows%20of%20glowing%20amber%20bulb%20lights%2C%20crimson%20velvet%20curtain%20edge%2C%20cinematic%20soft%20focus%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-03&orientation=landscape',
    comments: 742,
    likes: 690,
    hot: false,
  },
  {
    id: 't4',
    time: '17:20',
    date: '10月10日',
    tag: '明星爆料',
    title: '选秀爱豆被扒出情侣同款，工作室沉默三小时',
    excerpt:
      '粉丝从机场照中发现了同款配件，随后更多同款被陆续整理，话题热度持续攀升，官方仍未发声。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20quiet%20hotel%20corridor%20lit%20by%20amber%20wall%20sconces%20with%20long%20dramatic%20shadows%2C%20crimson%20carpet%20underfoot%2C%20cinematic%20depth%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-04&orientation=landscape',
    comments: 1533,
    likes: 1102,
    hot: true,
  },
  {
    id: 't5',
    time: '18:40',
    date: '10月10日',
    tag: '网红爆料',
    title: '知名美食博主被指摆拍，探店商家发声回应',
    excerpt:
      '有同行质疑其探店视频为摆拍，商家随后回应称并未受邀合作，博主方表示将公布完整素材。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20cozy%20cafe%20window%20at%20night%20with%20warm%20string%20lights%20and%20blurred%20amber%20bokeh%20scattered%20across%20the%20glass%2C%20cinematic%20depth%20of%20field%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-05&orientation=landscape',
    comments: 604,
    likes: 388,
    hot: false,
  },
  {
    id: 't6',
    time: '19:15',
    date: '10月10日',
    tag: '今日黑料',
    title: '综艺路透流出，嘉宾当场黑脸片段引热议',
    excerpt:
      '一段未播片段在网络流传，画面中嘉宾表情明显变化，节目组暂未就片段真实性作出说明。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20close%20up%20of%20a%20glowing%20smartphone%20screen%20in%20a%20dark%20room%20with%20warm%20amber%20ambient%20light%20and%20crimson%20reflections%2C%20cinematic%20mood%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-06&orientation=landscape',
    comments: 887,
    likes: 512,
    hot: false,
  },
  {
    id: 't7',
    time: '20:30',
    date: '10月10日',
    tag: '明星黑料',
    title: '导演新片选角争议升级，官微评论区沦为战场',
    excerpt:
      '新片公布主演阵容后引发讨论，网友围绕选角标准各执一词，官方账号评论区留言量激增。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20studio%20softbox%20and%20light%20stand%20silhouettes%20bathed%20in%20warm%20amber%20glow%20against%20crimson%20background%2C%20cinematic%20bokeh%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-07&orientation=landscape',
    comments: 1105,
    likes: 734,
    hot: true,
  },
  {
    id: 't8',
    time: '21:05',
    date: '10月10日',
    tag: '吃瓜',
    title: '女团成员退团传闻持续发酵，经纪公司深夜发声明',
    excerpt:
      '针对连日来的退团猜测，公司深夜发布简短声明，但措辞被指避重就轻，粉丝并不买账。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20empty%20concert%20stage%20with%20crimson%20velvet%20curtains%20and%20a%20dramatic%20golden%20spotlight%20haze%20cutting%20through%20smoke%2C%20cinematic%20depth%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=480&height=360&seq=hl-tl-08&orientation=landscape',
    comments: 1290,
    likes: 845,
    hot: false,
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流密会事件持续发酵', category: '明星黑料', heat: '98.6万', trend: 'up' },
  { rank: 2, title: '网红夫妻档带货翻车', category: '网红黑料', heat: '87.2万', trend: 'up' },
  { rank: 3, title: '影帝旧照曝光引热议', category: '明星爆料', heat: '76.5万', trend: 'flat' },
  { rank: 4, title: '选秀爱豆同款被扒', category: '明星黑料', heat: '71.9万', trend: 'up' },
  { rank: 5, title: '综艺未播片段流出', category: '今日黑料', heat: '64.3万', trend: 'down' },
  { rank: 6, title: '美食博主摆拍质疑', category: '网红黑料', heat: '58.7万', trend: 'flat' },
  { rank: 7, title: '新片选角争议升级', category: '明星爆料', heat: '52.4万', trend: 'up' },
  { rank: 8, title: '女团退团传闻回应', category: '吃瓜', heat: '47.1万', trend: 'down' },
];

export const collections = [
  {
    id: 'c1',
    title: '明星黑料档案',
    desc: '演艺圈一手爆料按人物归档',
    count: '3,102 条',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20crimson%20spotlight%20beam%20hitting%20a%20dark%20empty%20stage%20floor%20with%20golden%20dust%20motes%20drifting%2C%20dramatic%20cinematic%20haze%2C%20no%20people%2C%20no%20text%2C%20consistent%20crimson%20amber%20palette%2C%20high%20detail&width=600&height=450&seq=hl-col-01&orientation=landscape',
  },
  {
    id: 'c2',
    title: '网红翻车合集',
    desc: '直播带货名场面持续收录',
    count: '2,764 条',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20circular%20ring%20light%20glowing%20amber%20against%20a%20blurred%20crimson%20studio%20backdrop%20with%20soft%20bokeh%2C%20cinematic%20depth%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=600&height=450&seq=hl-col-02&orientation=landscape',
  },
  {
    id: 'c3',
    title: '今日吃瓜合辑',
    desc: '24 小时内最热事件速览',
    count: '326 条',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20pile%20of%20golden%20popcorn%20kernels%20glowing%20under%20amber%20light%20on%20a%20crimson%20cloth%20background%2C%20cinematic%20bokeh%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=600&height=450&seq=hl-col-03&orientation=landscape',
  },
  {
    id: 'c4',
    title: '热点追踪雷达',
    desc: '热搜词条发酵轨迹复盘',
    count: '188 条',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20radar%20sweep%20glow%20in%20amber%20and%20crimson%20on%20a%20dark%20screen%20with%20concentric%20rings%2C%20cinematic%20sci%20fi%20mood%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=600&height=450&seq=hl-col-04&orientation=landscape',
  },
  {
    id: 'c5',
    title: '往日经典瓜',
    desc: '历年高热度事件回顾',
    count: '420 条',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20vintage%20folded%20newspapers%20bathed%20in%20sepia%20amber%20light%20with%20crimson%20accents%2C%20nostalgic%20cinematic%20bokeh%2C%20no%20people%2C%20no%20readable%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=600&height=450&seq=hl-col-05&orientation=landscape',
  },
  {
    id: 'c6',
    title: '瓜田纪事',
    desc: '长期跟进的大事件专辑',
    count: '96 册',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20sunlit%20melon%20field%20rows%20glowing%20in%20amber%20golden%20hour%20light%20with%20crimson%20fruit%20accents%2C%20cinematic%20depth%2C%20no%20people%2C%20no%20text%2C%20consistent%20warm%20palette%2C%20high%20detail&width=600&height=450&seq=hl-col-06&orientation=landscape',
  },
];

export const comments = [
  {
    id: 'm1',
    name: '瓜田里的猹',
    initial: '瓜',
    text: '蹲一个后续，感觉这次工作室不会再装死了，赌五毛钱今晚有回应。',
    time: '12 分钟前',
    likes: 328,
  },
  {
    id: 'm2',
    name: '每天必吃瓜',
    initial: '吃',
    text: '时间线整理得很清楚，比我在别的平台刷半天强多了，收藏了。',
    time: '35 分钟前',
    likes: 214,
  },
  {
    id: 'm3',
    name: '冷静吃瓜派',
    initial: '冷',
    text: '先别急着站队，旧照这种东西很容易被断章取义，等实锤再说。',
    time: '1 小时前',
    likes: 486,
  },
  {
    id: 'm4',
    name: '热搜搬运工',
    initial: '搜',
    text: '第 4 条我下午就刷到了，没想到这里已经整理成合集，效率可以。',
    time: '2 小时前',
    likes: 152,
  },
  {
    id: 'm5',
    name: '半夜刷手机',
    initial: '夜',
    text: '就喜欢这种快讯流，一条一条往下看根本停不下来，已经凌晨了。',
    time: '3 小时前',
    likes: 297,
  },
  {
    id: 'm6',
    name: '路人甲乙丙',
    initial: '路',
    text: '希望网站能加个只看明星黑料的筛选，翻起来会更方便一点。',
    time: '4 小时前',
    likes: 88,
  },
];